module.exports = __webpack_public_path__ + "static/media/Specialty Flour.b09f32a5.png";